import { render, staticRenderFns } from "./ManagerProductCategoriesView.vue?vue&type=template&id=6d981289&scoped=true"
import script from "./ManagerProductCategoriesView.vue?vue&type=script&lang=js"
export * from "./ManagerProductCategoriesView.vue?vue&type=script&lang=js"
import style0 from "./ManagerProductCategoriesView.vue?vue&type=style&index=0&id=6d981289&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d981289",
  null
  
)

export default component.exports